import ButtonCopy from './src/main'

ButtonCopy.install = function (Vue) {
    Vue.components(ButtonCopy.name, ButtonCopy)
}

export default ButtonCopy